import React, { useEffect, useRef } from 'react';
import { useAppSelector } from '../store/hooks';
import { selectSettings } from '../store/slices/menuSlice';
import { parseRequire } from '../utils/parseImageUrl';
import { Sound } from './Sound';
import { store } from '../store/store';
import { TSoundINT, removeSound, selectSound } from '../store/slices/soundsSlice';

interface TSoundProps {

}

export const TSound: React.FC<TSoundProps> = ({ }) => {

    const soundSlice = useAppSelector(selectSound);
    const settingsSlice = useAppSelector(selectSettings);
    const music = useRef<{ gameSound: TSoundINT, soundObject: Sound; }[]>([]);

    useEffect(() => {
        if (music.current) {
            music.current.forEach(s => {
                s.soundObject.sound.volume(settingsSlice.musicVolume ? settingsSlice.musicVolume / 100 : 0);
            });
        }

    }, [settingsSlice]);
    useEffect(() => {
        // if (soundSlice.length == null) {
        //     return;
        // }
        // if (!soundSlice.length) {

        music.current?.forEach(s => {
            if (!soundSlice.sound.length || soundSlice.sound.find(_s => _s.key !== s.gameSound.key)) {
                s.soundObject.stop();
            }
        });
        // return;
        // }
        soundSlice?.sound?.forEach?.(s => {
            if (music.current.find(_s => _s.gameSound.key === s.key)) {
                // return;
            }
            if (s?.options?.shouldPlay) {
                startSound(s);
            } else {
                stopSound(s);

            }
        });
    }, [soundSlice, settingsSlice]);

    function onEnded(key: string, soundId: number) {
        const existsIndex = soundSlice.sound.findIndex(s => s.key === key);
        if (existsIndex >= 0) {
            if (soundSlice?.sound?.[existsIndex].options?.loop) {
                startSound(soundSlice?.sound?.[existsIndex]);
            } else {
                store.dispatch(removeSound(key));
                // music.current = music.current.filter(s => !s.gameSound.key && !s.gameSound.options?.loop);
            }
        }
        // music.current.forEach(s => {
        //     if (s.key === key) {
        //         if (s.soundObject.)
        //     }
        // });

    }
    function stopAll(sound: TSoundINT) {
        // if (sound.options?.type === "music") {

        // } else {

        // }
        soundSlice?.sound.forEach(s => {
            if (s.options?.type && s.options?.type === sound.options?.type) {
                stopSound(s);
            }
        });
    }

    function startSound(sound: TSoundINT) {
        if (sound.options?.multiplePlay) {
            stopSound(sound);
        } else {
            stopAll(sound);

        }
        const soundObject = new Sound(sound.url, sound.key!, settingsSlice.musicVolume != null ? settingsSlice.musicVolume / 100 : 0, (id, err) => {
            console.log(err);
        }, onEnded);
        music.current?.push({ gameSound: sound, soundObject });
        soundObject.play().then(a => {
        });
    }
    function stopSound(sound: TSoundINT) {
        // music.current = new Sound(soundSlice.url, settingsSlice.musicVolume ? settingsSlice.musicVolume / 100 : 0, (err) => {
        //     console.log(err);
        // });
        // music.current.play().then(a => {
        //     console.log("a", a);
        // });
        const index = music.current?.findIndex(s => s.gameSound.key === sound.key);
        if (index >= 0) {
            music.current?.at(index)?.soundObject.stop();
            music.current.splice(index, 1);
        }
    }


    // var Sound = require('react-native-sound');
    // const whoosh = new Sound(require("@lss/common/game/assets/sounds/Ringtone.wav"), Sound.MAIN_BUNDLE, (error:any) => {
    //     if (error) {
    //         console.log('failed to load the sound', error);
    //         return;
    //     }
    //     // loaded successfully
    //     console.log('duration in seconds: ' + whoosh.getDuration() + 'number of channels: ' + whoosh.getNumberOfChannels());

    //     // Play the sound with an onEnd callback
    //     whoosh.play((success:any) => {
    //         if (success) {
    //             console.log('successfully finished playing');
    //         } else {
    //             console.log('playback failed due to audio decoding errors');
    //         }
    //     });
    // });
    return null;
};